import * as Styles from './styles';

export const Image = ({
  src,
  alt,
  width,
  height,
  objectFit,
  borderRadius,
}: {
  src: any;
  alt: string;
  width?: number;
  height?: number;
  borderRadius?: number | undefined;
  objectFit?: 'none' | 'fill' | 'cover';
}) => (
  <Styles.Image
    src={src}
    alt={alt}
    width={width}
    height={height}
    objectFit={objectFit}
    borderRadius={borderRadius ?? 0}
  />
);
